export default {
  // 模块名称
  deviceMg: {
    // 按钮类
    button: {
      add: 'Add',
      delete: 'Delete',
      batchDelete: 'Batch Delete',
      edit: 'Edit',
      save: 'Save',
      Cancel: 'Cancel',
      confirm: 'Confirm'
    },
    // 文字标签类
    label: {
      cameraName: 'camerasName',
      type: 'Type',
      car: 'Number',
      people: 'Face',
      area: 'Area',
      createTime: 'createTime'
    },
    // 提示类
    placeholder: {
      cameraName: 'Please enter the name of the camera crew',
      area: 'Please select area',
      startTime: 'Select start time',
      endTime: 'Select end time'
    },
    // 消息类
    message: {
      area: 'Please select area',
      details: 'Request details failed',
      abnormal: 'Abnormal request',
      deleteWarn: 'This operation will permanently delete the camera set. Do you want to continue?',
      batchDeleteWarn: 'This operation will permanently batch deletion the camera set. Do you want to continue?',
      deleteSuccess: 'successfully delete ',
      noDelete: 'You have not selected the camera set to delete',
      deleteFail: 'fail to delete',
      create: 'Creating a successful',
      editSuccess: 'modify successfully',
      cameraName: 'Please enter the name of the camera crew',
      length: 'Minimum length of 3 characters',
      value: 'Please input Chinese, English and numeric combination',
      type: 'Please select type',
      coordinate: 'The camera has no latitude or longitude information',
      values: 'Length is less than 30 characters'
    },
    // 标题类
    title: {
      add: 'Add',
      select: 'Select',
      edit: 'edit',
      remind: 'remind',
      cameraList: 'cameraList',
      startTime: 'startTime',
      endTime: 'endTime',
      choseCamera: 'choseCamera',
      information: 'No Data'
    }
  }
}